import { AnchorLink } from 'components/Link';
import { cn } from 'utils/classNames';

interface Props {
	/** Extra class names */
	className?: string;

	/** Scroll to target element? */
	scroll?: boolean;

	/** Element ID to target */
	target: string;

	/** Link text */
	text: string;

	/** Underline the text when active. */
	underline?: boolean;

	/** How to display the link */
	variant?: 'absolute' | 'inline';
}

/** Hidden block link that becomes visible on focus. */
export default function Skiplink({
	className,
	scroll = true,
	target,
	text,
	underline = false,
	variant = 'inline',
}: Props) {
	return (
		<AnchorLink
			anchor={target}
			scroll={scroll}
			className={cn(
				className,
				'sr-only flex items-center justify-center bg-positive text-center font-bold text-negative',
				'focus:not-sr-only focus:min-h-14 focus:p-3',
				underline && 'focus:underline',
				'md:text-lg',
				variant === 'inline' && 'focus:w-full',
				variant === 'absolute' &&
					'top-0 left-0 z-10 rounded-sm focus:absolute focus:px-6',
			)}
		>
			{text}
		</AnchorLink>
	);
}
Skiplink.displayName = 'Skiplink';
